import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import {Events, LoadingController} from 'ionic-angular';
import {Network} from '@ionic-native/network';
import { environment } from '../../environments/environment';
import {Observable} from "rxjs";
/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
    isLoading: boolean = false;
    showLoading: boolean = true;
    checkNetwork: boolean = true;
    constructor(
        public http: HttpClient,
        public loadingController: LoadingController,
        public events: Events,
        public network: Network
    ) {
        this.init();
    }

    init() {

    }
    getUrl(endpoint: string) {
        return endpoint.replace(environment.root, '');
    }

    get(endpoint: string, params?: any, reqOpts?: any) {
        
        if (this.checkNetwork && this.network.type == 'none') {
            let observable = new Observable(observer => {
                observer.next({ 'data': [] });
                this.sendNetwork();
            });
            return observable;
        }
        if (params && 'showLoading' in params) {
            this.showLoading = params.showLoading;
        } else {
            this.showLoading = false;
        }
        let loader = null;

        loader = this._setLoader();


        if (!reqOpts) {
            reqOpts = {
                params: new HttpParams()
            };
        }

        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new HttpParams();
            for (let k in params) {
                reqOpts.params = reqOpts.params.set(k, params[k]);
            }
        }
        console.log('=====================================================');

        let request = this.http.get(endpoint, reqOpts).pipe(
            tap(res => {
                this._hideLoader(loader);
                return res;
            }),
            catchError(e => {
                console.log(e);
                this.showAlert(e);
                throw e;
            })
        );
        
        return request;


    }

    post(endpoint: string, body: any) {
        if (this.checkNetwork && this.network.type == 'none') {
            let observable = new Observable(observer => {
                observer.next({ 'data': [] });
            });
            this.sendNetwork();
            return observable;
        }
        if ('showLoading' in body) {
            this.showLoading = false;
        } else {
            this.showLoading = true;
        }
        let loader = this._setLoader();
        return this.http.post(endpoint, body).pipe(
            tap(res => {
                this._hideLoader(loader);
                return res;
            }),
            catchError(e => {
                this._hideLoader(loader);
                console.log(e);
                this.showAlert(e);
                throw e;
            })
        );

    }

    put(endpoint: string, body: any, reqOpts?: any) {
        if (this.checkNetwork && this.network.type == 'none') {
            let observable = new Observable(observer => {
                observer.next({ 'data': [] });
            });
            this.sendNetwork();
            return observable;
        }
        return this.http.put(endpoint, body, reqOpts).pipe(
            tap(res => {

                return res;
            }),
            catchError(e => {
                this.showAlert(e);
                throw e;
            })
        );
    }

    delete(endpoint: string, reqOpts?: any) {
        if (this.checkNetwork && this.network.type == 'none') {
            let observable = new Observable(observer => {
                observer.next({ 'data': [] });
            });
            this.sendNetwork();
            return observable;
        }
        return this.http.delete(endpoint, reqOpts).pipe(
            tap(res => {

                return res;
            }),
            catchError(e => {
                this.showAlert(e);
                throw e;
            })
        );
    }

    patch(endpoint: string, body: any, reqOpts?: any) {
        if (this.checkNetwork && this.network.type == 'none') {
            let observable = new Observable(observer => {
                observer.next({ 'data': [] });
            });
            this.sendNetwork();
            return observable;
        }
        return this.http.patch(endpoint, body, reqOpts).pipe(
            tap(res => {

                return res;
            }),
            catchError(e => {
                this.showAlert(e);
                throw e;
            })
        );
    }

    showAlert(msg: string) {
        console.log(msg);
    }

    private _setLoader() {
        if (this.isLoading == false && this.showLoading) {
            let loader = this.loadingController.create({
                content: ''
            });
            loader.present();
            this.isLoading = true;
            return loader;
        }
        return null;
    }

    private _hideLoader(loader) {
        if (loader != null) {
            loader.dismiss();

        }
        this.isLoading = false;
    }

    sendNetwork(){
        this.events.publish('network:status', this.network.type);
    }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts